export default "__VITE_ASSET__DvZHuiGI__"